'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

require('./InboxHeader.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InboxHeader = function InboxHeader(props) {
    var closeInboxHandler = props.closeInboxHandler;


    var CloseButton = _react2.default.createElement(
        'div',
        { className: 'close-inbox' },
        _react2.default.createElement(
            _Button2.default,
            { onClickFn: closeInboxHandler },
            _react2.default.createElement(
                'span',
                null,
                'Close'
            )
        )
    );

    return _react2.default.createElement(
        'div',
        { className: 'InboxHeader' },
        _react2.default.createElement(
            'h2',
            { className: 'inbox-title' },
            'Unsorted notes'
        ),
        closeInboxHandler ? CloseButton : null
    );
};

InboxHeader.propTypes = {
    gridSize: _propTypes2.default.number,
    closeInboxHandler: _propTypes2.default.func,
    className: _propTypes2.default.string
};

exports.default = InboxHeader;


//////////////////
// WEBPACK FOOTER
// ./src/client/inbox/InboxHeader.js
// module id = 743
// module chunks = 0